module.exports = __webpack_public_path__ + "img/Physics.630da9de.svg";